(()=>{
  const FLEET_NAMES=Object.freeze({
    1:"Transit Quintos Blue",
    2:"Renault Master L1 Rovato",
    3:"Volkswagen Crafter 3 VA",
    4:"Fiat Ducato L3 TO",
    5:"Ford Transit Blue",
    6:"Peugeot Boxer Blue",
    7:"Citroen Jumper telonato",
    8:"Volkswagen Crafter 1",
    9:"Ford Transit B A",
    10:"Fiat Ducato L1",
    12:"Renault Traffic Quintos",
    13:"Mercedes Vito",
    14:"Hyundai H350",
    15:"Fiat Ducato cassonato",
    16:"Volkswagen Crafter 2",
    17:"Ford Custom",
    18:"Renault Master Euro 5",
    19:"Ford Transit"
  });

  const normalize=value=>String(value??"")
    .normalize("NFD").replace(/[\u0300-\u036f]/g,"")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g," ")
    .trim()
    .replace(/\s+/g," ");

  const NAME_TO_NUMBER=Object.freeze(Object.fromEntries(
    Object.entries(FLEET_NAMES).map(([number,name])=>[normalize(name),Number(number)])
  ));

  const readModelName=item=>[
    item?.name,
    item?.model_name,
    item?.modelName,
    item?.title,
    item?.model?.name,
    item?.vehicle_model?.name,
    item?.vehicleModel?.name
  ].find(value=>typeof value==="string"&&value.trim())||"";

  const readAvailability=item=>{
    for(const key of ["available","is_available","isAvailable"]){
      if(typeof item?.[key]==="boolean")return item[key];
    }
    const status=normalize(item?.status??item?.availability??item?.availability_status??item?.availabilityStatus??"");
    if(["available","disponibile","free","libero"].includes(status))return true;
    if(["unavailable","not available","non disponibile","busy","occupied","occupato"].includes(status))return false;
    const quantity=Number(item?.available_quantity??item?.availableQuantity??item?.availability_count??item?.availabilityCount);
    return Number.isFinite(quantity)?quantity>0:null;
  };

  window.MASSAGOMME_RENTHUB_NAME_MAP=FLEET_NAMES;
  window.MASSAGOMME_RENTHUB_NUMBER_FROM_NAME=name=>NAME_TO_NUMBER[normalize(name)]||null;
  window.MASSAGOMME_RENTHUB_NAME_FROM_NUMBER=number=>FLEET_NAMES[Number(number)]||null;
  window.MASSAGOMME_MAP_RENTHUB_MODELS=models=>{
    const rows=Array.isArray(models)?models:[];
    const map={};
    rows.forEach(item=>{
      const number=NAME_TO_NUMBER[normalize(readModelName(item))];
      if(!number)return;
      const state=readAvailability(item);
      if(state!==null)map[number]=state;
    });
    return map;
  };
})();